import * as React from "react";
import { connect } from "react-redux";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as ProxyHelper from "../proxyManagement/ProxyHelper";

class FamilyWithNoMember extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { useOnboardingLayout} = this.props;
        logUI(`MBHWeb.UI.FamilyWithNoMember.ComponentDidMount${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
    }

    render() {
        const { btnprops } = this.props;
        const heading = "Conveniently access your family member's health information in MyBSWHealth";
        return (
            <div className="container-fluid family-withnomember-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="step-heading step-heading-md">{heading}</h1>
                            </div>
                            <div className="col-12">
                                {btnprops}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        useOnboardingLayout: state.session.useOnboardingLayout
    };
};
export default connect(mapStateToProps)(FamilyWithNoMember);